import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();
  const [isFaqOpen, setIsFaqOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  const toggleFaq = () => {
    setIsFaqOpen(!isFaqOpen);
  };

  const toggleTerms = () => {
    setIsTermsOpen(!isTermsOpen);
  };

  const togglePrivacy = () => {
    setIsPrivacyOpen(!isPrivacyOpen);
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          <div className="footer-col">
            <h4>{t('footer.navigation')}</h4>
            <ul>
              <li><a href="/login">{t('footer.admin')}</a></li>
              <li>
                <button type="button" className="footer-link-btn" onClick={toggleTerms}>
                  Terms &amp; Conditions
                </button>
              </li>
              <li>
                <button type="button" className="footer-link-btn" onClick={togglePrivacy}>
                  Privacy Policy
                </button>
              </li>
            </ul>
            
            {/* QR Code below Admin link */}
            <div className="qr-code-section">
              <h5 style={{ fontSize: '0.85rem', marginBottom: '0.4rem', color: '#fff', marginTop: '0' }}>Visit Us</h5>
              <div 
                className="qr-code-container"
                onClick={() => window.open('https://www.google.com/maps/search/Telangana+Vikalangula+Cooperative+Corporation+Nalgonda+X+Roads+Malakpet+Hyderabad', '_blank')}
                style={{ cursor: 'pointer' }}
                title="Click or scan to open location in Google Maps"
              >
                <img 
                  src="https://api.qrserver.com/v1/create-qr-code/?size=110x110&data=https://www.google.com/maps/search/Telangana+Vikalangula+Cooperative+Corporation+Nalgonda+X+Roads+Malakpet+Hyderabad" 
                  alt="QR Code - Location Map" 
                  className="qr-code-image"
                  style={{
                    width: '110px',
                    height: '110px',
                    backgroundColor: '#fff',
                    padding: '6px',
                    borderRadius: '6px',
                    display: 'block'
                  }}
                />
                <p style={{ 
                  fontSize: '0.7rem', 
                  marginTop: '0.3rem', 
                  color: '#ccc',
                  textAlign: 'center',
                  marginBottom: '0'
                }}>
                  Scan for Map
                </p>
              </div>
            </div>
          </div>
          <div className="footer-col center-logo">
            <div className="footer-logo">
              <img 
                src="/assets/images/tglogo.png" 
                alt="Government of Telangana Logo" 
                className="logo-image" 
                onError={(e) => {
                  // Fallback to secondary logo if main logo fails
                  if (e.target.src !== '/assets/images/image1.jpeg') {
                    e.target.src = '/assets/images/image1.jpeg';
                  } else {
                    // If both fail, hide the image and show text
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }
                }} 
              />
              <div className="logo-fallback" style={{display: 'none'}}>
                <span className="fallback-text">GOVERNMENT OF TELANGANA</span>
              </div>
            </div>
          </div>
          <div className="footer-col">
            <h4>{t('footer.contactDetails')}</h4>
            <div className="contact-info">
              <p>{t('footer.addressLine1')}</p>
              <p>{t('footer.addressLine2')}</p>
              <p>{t('footer.addressLine3')}</p>
              <p>{t('footer.addressLine4')}</p>
              {/* <p>{t('footer.phone')}</p> */}
              <p 
                className="contact-clickable"
                onClick={() => window.open('tel:04024559048')}
                title="Click to call"
              >
                Landline: 04024559048
              </p>
              <p 
                className="contact-clickable"
                onClick={() => window.open('tel:155326')}
                title="Click to call"
              >
                TG Helpline: 155326
              </p>
              <p 
                className="contact-clickable"
                onClick={() => window.open('mailto:cdwtghyd@gmail.com')}
                title="Click to send email"
              >
                Email: cdwtghyd@gmail.com
              </p>
            </div>
            
            <div className="social-media">
              <a href="#" className="social-icon facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="social-icon twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="social-icon instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="social-icon youtube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <div className="copyright">
            <span>{t('footer.copyright')}</span>
          </div>
          <div className="powered-by">
            {/* <span>Powered by</span> */}
            <div className="partner-logos">
              {/* <div className="youth4jobs-logo">Youth4Jobs</div> */}
              <div className="swaraj-ability-logo">
                {/* <div className="wheelchair-icon"></div> */}
                
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Terms & Conditions Modal */}
      {isTermsOpen && (
        <div className="faq-modal-overlay" onClick={toggleTerms}>
          <div className="terms-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="terms-modal-header">
              <h2>Terms &amp; Conditions</h2>
              <button 
                className="faq-modal-close-btn" 
                onClick={toggleTerms}
                aria-label="Close Terms &amp; Conditions"
              >
                ×
              </button>
            </div>
            <div className="terms-modal-body">
              <p>
                Transgender Persons Job Portal offers services to employers and candidates. By accessing or using the portal you agree to the following terms:
              </p>
              <ol className="terms-list">
                <li>
                  Transgender Persons Job portal offers a gamut of services for employers. These services include, but are not limited to:
                  <ul>
                    <li>Free registration of Employers.</li>
                    <li>Simplified vacancy posting system.</li>
                    <li>Access to large candidate database from all over the State.</li>
                    <li>Customized alerts for the registered users through emails/SMS.</li>
                    <li>Availability of dynamic job matching.</li>
                    <li>Information on Job Fairs.</li>
                  </ul>
                </li>
                <li>
                  Transgender Persons Job portal provides information to stakeholders on the basis of information/data shared by the users and is not responsible for credibility of the information shared.
                </li>
                <li>
                  The user agrees to receive SMS communications from Transgender Persons Job portal regarding portal features and benefits.
                </li>
                <li>
                  Users do not claim any copyright or Intellectual Property Rights over data uploaded and must abide by relevant rules and regulations.
                </li>
                <li>
                  Transgender Persons Job portal offers neither guarantee nor warranties of satisfactory response once information/data is provided.
                </li>
                <li>
                  Transgender Persons Job portal neither guarantees nor offers warranty about credentials or status of jobseekers who may contact employers.
                </li>
                <li>
                  Employers agree that no fee will be charged from any person responding to jobs posted on the portal.
                </li>
                <li>
                  By posting jobs, employers confirm they possess necessary licenses/permits and indemnify Transgender Persons Job portal against related claims.
                </li>
                <li>
                  Upon registration, users agree that information advertised through the portal is authentic and existing.
                </li>
                <li>
                  Job postings remain live for the specified duration. Each re-posting or edit is treated as a fresh posting.
                </li>
                <li>
                  Employers will provide accurate contact information as per the job posting form to collect responses.
                </li>
                <li>
                  Transgender Persons Job portal does not interfere with employers’ recruitment processes, though employers are encouraged to describe the process clearly.
                </li>
                <li>
                  Users are responsible for verifying authenticity of responses received. The portal assumes no liability for actions taken on such responses.
                </li>
                <li>
                  Transgender Persons Job portal reserves the right to delete any profile or data violating regulations, and may discontinue user access if false or misleading information is provided.
                </li>
                <li>
                  Transgender Persons Job portal may change the look, design, or classification of information templates without notice.
                </li>
                <li>
                  Users shall not engage in unlawful activities under false association with the portal. Legal recourse may be taken against violators.
                </li>
                <li>
                  Users are responsible for safeguarding their passwords. The portal is not liable for loss, theft, misuse, or corruption of data arising from compromised credentials.
                </li>
                <li>
                  Disputes shall be resolved in accordance with the laws of India.
                </li>
                <li>
                  Despite use of latest technology, the portal is not liable for loss of data due to causes beyond its control including but not limited to strikes, riots, Govt. policies, hacking, or natural calamities.
                </li>
                <li>
                  These terms cease to apply upon completion of the service term engaged by the user.
                </li>
              </ol>

              <div className="terms-consent">
                <h3>Consent for Authentication</h3>
                <p>
                  I hereby state that I give my consent in providing my Transgender ID card to the Transgender Persons Job portal platform. I understand that my personal data from the National Transgender portal would be fetched into the Transgender Persons Job Portal platform for the purpose of registration/authentication. I acknowledge that Transgender Persons Job portal Foundation shall ensure security and confidentiality of my Transgender ID and/or other organizational KYC data being provided for the purpose of finding a job.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Privacy Policy Modal */}
      {isPrivacyOpen && (
        <div className="faq-modal-overlay" onClick={togglePrivacy}>
          <div className="privacy-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="privacy-modal-header">
              <h2>Privacy Policy</h2>
              <button
                className="faq-modal-close-btn"
                onClick={togglePrivacy}
                aria-label="Close Privacy Policy"
              >
                ×
              </button>
            </div>
            <div className="privacy-modal-body">
              <h3>1. Introduction</h3>
              <p>
                We, at Transgender Persons Job Portal, are committed to respecting your privacy and
                protecting any personally identifiable information you share with us. This Privacy
                Policy explains how the portal collects, uses, discloses, and safeguards personal
                information of users across our websites, mobile applications, and online services.
                By accessing or using the platform, you consent to the practices described in this
                policy.
              </p>

              <h3>2. Types of Personal Information Collected</h3>
              <p>
                Personal Information refers to any data that can identify an individual. We collect
                information based on how you interact with us, including but not limited to:
              </p>
              <ul className="privacy-list">
                <li>
                  Details provided during sign up such as name, email, password, country, city,
                  contact number, and organization.
                </li>
                <li>
                  Resume information including gender, Transgender ID card details, contact
                  information, work experience, education, and salary data.
                </li>
                <li>Usage data, log information, and location information when you use our services.</li>
                <li>
                  Survey responses and preferences you voluntarily share through forms or
                  questionnaires.
                </li>
                <li>
                  Communications with the portal or other users through the platform, including the
                  content you provide.
                </li>
                <li>
                  Technical information collected via cookies, devices, and other technologies.
                </li>
                <li>
                  Information obtained for compliance with legal obligations, including recorded
                  communications where permitted by law.
                </li>
              </ul>

              <h3>3. How We Use Your Personal Information</h3>
              <p>
                Transgender Persons Job Portal processes personal information for lawful purposes
                connected with delivering our services. Depending on how you interact with us, we
                may use your data to:
              </p>
              <ul className="privacy-list">
                <li>Provide portal services, job alerts, and personalized recommendations.</li>
                <li>Improve platform features, content, and user experience.</li>
                <li>Communicate service updates, support, and relevant information.</li>
                <li>
                  Prevent, detect, investigate, and act against fraud, illegal activities, or
                  policy violations.
                </li>
                <li>Authenticate identity, conduct due diligence, and comply with regulations.</li>
                <li>
                  Establish, exercise, or defend legal rights in connection with proceedings.
                </li>
              </ul>

              <h3>4. Links to Other Sites</h3>
              <p>
                The platform may contain limited hyperlinks to external websites. Transgender Persons
                Job Portal is not responsible for the privacy practices or content of those sites, and
                users are encouraged to review their respective policies.
              </p>

              <h3>5. Security</h3>
              <p>
                We implement stringent security measures to protect the information under our control
                against loss, misuse, unauthorized access, alteration, or destruction.
              </p>

              <h3>6. Basis for Processing Personal Information</h3>
              <p>
                We collect and process personal information with your consent and for legitimate
                purposes related to service delivery, reporting, and compliance. By using the portal,
                you acknowledge that personal data provided is required for the stated purposes and may
                be published in non-sensitive aggregate reports.
              </p>

              <h3>7. Information Sharing and Disclosure</h3>
              <p>
                Access to personal information is restricted to stakeholders who need it to operate,
                develop, or improve services. We may share information with:
              </p>
              <ul className="privacy-list">
                <li>Portal stakeholders for internal, administrative, or operational purposes.</li>
                <li>
                  Potential recruiters when your profile matches a vacancy, subject to your consent.
                </li>
                <li>
                  Law enforcement or regulatory authorities where required by law or to protect legal
                  rights.
                </li>
                <li>
                  Third-party service providers bound by confidentiality obligations to support portal
                  operations.
                </li>
              </ul>
              <p>
                We will not transfer personal information without consent unless legally required.
              </p>

              <h3>8. Third-Party Content</h3>
              <p>
                The platform may refer users to third-party sites. We are not responsible for how such
                sites store or use personal data. Please review the privacy policies of any linked
                services you visit.
              </p>

              <h3>9. Children</h3>
              <p>
                Users must be at least 18 years old, or the age of majority in their jurisdiction, to
                use the platform independently. Minors must access the portal under supervision of a
                parent, guardian, or responsible adult.
              </p>

              <h3>10. Retention of Personal Information</h3>
              <p>
                Personal information is retained only as long as necessary for the purposes outlined in
                this policy or as required by legal, regulatory, or contractual obligations. After that
                period, the data is deleted or archived in compliance with applicable laws.
              </p>

              <h3>11. Confidentiality and Security</h3>
              <p>
                Transgender Persons Job Portal invests significant resources to protect the safekeeping
                and confidentiality of your data and adheres to applicable information technology rules
                regarding sensitive personal information.
              </p>

              <h3>12. Social Media</h3>
              <p>
                The portal may operate social media channels to inform and engage users. Please refrain
                from sharing sensitive personal data or inappropriate content through these channels.
                The portal is not responsible for user-generated content on third-party platforms.
              </p>

              <h3>13. Changes to this Privacy Policy</h3>
              <p>
                We may update this Privacy Policy from time to time. Changes become effective upon
                publication. If you share information not explicitly requested, the portal is not liable
                for any disclosure related to such information.
              </p>

              <h3>14. Grievance Officer</h3>
              <p>
                For questions or concerns, please contact our Grievance Officer at{' '}
                <a href="mailto:grievance@TransgenderpersonsJOBPORTALindia.org">
                  grievance@TransgenderpersonsJOBPORTALindia.org
                </a>
                .
              </p>

              <h3>15. Disclaimer</h3>
              <p>
                Transgender Persons Job Portal does not store account details or payment information and
                is not liable for loss or damage arising from disclosure of such data during online
                transactions conducted on third-party systems.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* FAQ Modal */}
      {isFaqOpen && (
        <div className="faq-modal-overlay" onClick={() => setIsFaqOpen(false)}>
          <div className="faq-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="faq-modal-header">
              <h2>Frequently Asked Questions</h2>
              <button 
                className="faq-modal-close-btn" 
                onClick={() => setIsFaqOpen(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="faq-modal-body">
              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">❓</span>
                  <h3>Who can register on this portal?</h3>
                </div>
                <p>Transgender individuals and employers from Telangana can register to access employment opportunities.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">💰</span>
                  <h3>Is registration free?</h3>
                </div>
                <p>Yes, registration is completely free. This is a government initiative to promote inclusive employment.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">⏱️</span>
                  <h3>How long does approval take?</h3>
                </div>
                <p>Account approval typically takes 3-5 business days after document verification by our admin team.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">🔑</span>
                  <h3>How do I reset my password?</h3>
                </div>
                <p>Use the "Forgot Password" option on the login page or contact TG Helpline: 155326 for assistance.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">📄</span>
                  <h3>What documents are required?</h3>
                </div>
                <p>Valid ID proof, address proof, and for candidates - transgender certificate if available. Employers need company registration certificate.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">📧</span>
                  <h3>How will I know if my account is approved?</h3>
                </div>
                <p>You will receive an email and SMS notification once your account is approved or if any additional documents are required.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">🔒</span>
                  <h3>Is my personal information secure?</h3>
                </div>
                <p>Yes, all your personal information is encrypted and stored securely. We follow strict data protection policies in compliance with government regulations.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">💼</span>
                  <h3>How do I apply for jobs?</h3>
                </div>
                <p>Once your account is approved, you can browse available job listings and apply directly through your candidate dashboard.</p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">📞</span>
                  <h3>Who do I contact for support?</h3>
                </div>
                <p>For any assistance, you can contact:<br/>
                   <strong>TG Helpline:</strong> 155326<br/>
                   <strong>Email:</strong> cdwtghyd@gmail.com<br/>
                   <strong>Landline:</strong> 04024559048
                </p>
              </div>

              <div className="faq-modal-item">
                <div className="faq-question">
                  <span className="faq-icon">🏢</span>
                  <h3>Can employers post multiple job openings?</h3>
                </div>
                <p>Yes, approved employers can post unlimited job openings and manage them through their employer dashboard.</p>
              </div>
            </div>
            <div className="faq-modal-footer">
              <p>Still have questions? Contact us at <strong>cdwtghyd@gmail.com</strong> or call <strong>155326</strong></p>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;

